<template>
  <div class="parent">
    <div class="divTitle">
      <div class="divTitleDisplay">
        <img src="../../img/baseStart.png" /><span>{{ title }}</span
        ><img src="../../img/baseEnd.png" />
      </div>
      <div class="divDescribe">{{ desc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    bgFont: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
.divTitle {
  padding-top: 86px;
  padding-bottom: 86px;
  position: relative;
  .divTitleDisplay {
    height: 56px;
    font-size: 34px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 56px;
    position: relative;
    img {
      height: 22px;
    }
    span {
      margin-left: 20px;
      margin-right: 20px;
    }
  }

  .divDescribe {
    height: 30px;
    font-size: 22px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(255, 255, 255, 1);
    line-height: 30px;
    margin-top: 13px;
  }
}
</style>
